<mat-toolbar>
  <div>
    @if (isMobile) {
      <button mat-icon-button (click)="openMenu()" data-cy="menu-button">
        <mat-icon style="vertical-align: middle;">menu</mat-icon>
      </button>
    }
  </div>

  <div class="flex toolbar-actions">
    @if (school?.googleIntegration) {
      <button class="user-menu-trigger google-menu-trigger" [matMenuTriggerFor]="googleMenu" data-cy="google-menu-btn">
        <div class="user-avatar">
          <mat-icon>apps</mat-icon>
        </div>
      </button>
    }

    <button class="user-menu-trigger" [matMenuTriggerFor]="userMenu" data-cy="profile-menu-btn">
      <div class="user-avatar">
        <mat-icon>person</mat-icon>
      </div>
      <div class="user-info">
        <span class="user-name">{{ userName}} <mat-icon class="chevron">expand_more</mat-icon></span>
      </div>
    </button>
    <mat-menu #userMenu="matMenu" xPosition="before">

      <button mat-menu-item (click)="goToHelp()">Aide</button>
      @if (school?.itSchoolLink) {
      <button mat-menu-item (click)="goToItSchool()">iT SCHOOL</button>
      }
      @if (school?.microsoftIntegration) {
      <button mat-menu-item (click)="goToOffice365()" data-cy="office365-btn">Office 365</button>
      }
      @if (profiles.length > 1) {
      <button mat-menu-item (click)="changeProfile()">Changer de profil</button>
      }
      <button mat-menu-item (click)="about()">A propos</button>

      <button mat-menu-item (click)="logout()" data-cy="logout-button">Se déconnecter</button>
    </mat-menu>

    <mat-menu #googleMenu="matMenu" xPosition="before">
      <div class="flex flex-row g-apps">
        <button mat-button class="g-app" (click)="goToGoogle('gmail')">
          <div>
            <span class="g-app-icon" style="background-position: 0 -2001px;">
            </span>
          </div>
          <span class="g-app-name">Gmail</span>
        </button>
        <button mat-button  class="g-app" (click)="goToGoogle('classroom')">
          <div class="g-app-icon-container">
            <span class="g-app-icon" style="background-position: 0 -966px;">
            </span>
          </div>
          <span class="g-app-name">Classroom</span>
        </button>
        <button mat-button  class="g-app" (click)="goToGoogle('drive')">
          <div class="g-app-icon-container">
            <span class="g-app-icon" style="background-position: 0 -2967px;">
            </span>
          </div>
          <span class="g-app-name">Drive</span>
        </button>
      </div>
    </mat-menu>
  </div>
</mat-toolbar>